export const LOG_OUT_HEADER_TOOLTIP = 'You will be logged out from all HG Insights products.';
export const LINK_LOG_OUT = 'Log out';
export const SEGMENTS_LINK = 'Segments';
export const CONTACT_US = 'CONTACT US';
